// Module
var code = "<h2 id=\"account-authorizations\">Account Authorizations</h2> <p>Designate people who can discuss your loan account with us on your behalf.</p> ";
// Exports
export default code;